export const fieldDefinitions = {
  school_name:
    'The name of the specific school the student attends within district',
  name_prefix:
    "A title used before a student's name (e.g., Mr., Ms.) This may not be relevant for most students.",
  name_first: 'The first name of the student',
  name_middle: 'The middle name of the student',
  name_last: 'The last name or surname of the student',
  name_suffix: "A suffix that follows a student's name (e.g., Jr., III)",
  name_preferred: 'The preferred name that the student goes by',
  clever_id: "The student's unique Clever identifier",
  organization_student_id:
    "The student's identification number within school/district",
  local_student_id:
    'A locally assigned identification number for the student, if different from their organization identifier',
  state_student_id: 'The statewide student identifier',
  email: 'The email address associated with the student',
  grade: 'The grade level of the student (e.g., 6, 7, 8)',
  dob: 'The date of birth of the student',
  gender: 'The gender of the student',
  race: 'The racial background of the student',
  is_hispanic: 'Indicates whether the student identifies as Hispanic (Yes/No)',
  is_low_income:
    'Indicates whether the student is from a low-income family (Yes/No)',
  has_iep: 'Indicates whether the student has an IEP (Yes/No)',
  first_lang_not_english: "The student's first language if it is not English",
  el_status: 'English Learner (EL) status (Yes/No)',
  eld_level:
    'English Language Development (ELD) level based on proficiency scale used by school/district, if relevant',
  primary_disability: "The student's primary disability, if applicable",
  has_504: 'Indicates whether the student has a 504 plan (Yes/No)',
  flep_date: 'Date that student shifted from ESL programming to FEL monitoring',
  home_language: "The language spoken at the student's home",
  is_immigrant: 'Indicates whether the student is an immigrant',
  us_entry_date: "Date of student's entry into the United States",
  birth_city: 'The city where the student was born',
  birth_state: 'The state where the student was born',
  birth_country: 'The country where the student was born',
  is_homeless: 'Indicates whether the student is currently unhoused',
  in_fostercare: 'Indicates whether the student is currently in foster care',

  'Parttime bl, should be fulltime bl':
    'enrolled in part-time bilingual program, should be full-time bilingual program',
  'Special ed': 'student has IEP',
  Waiver: 'certain LEP serves waived for student',
  'Part-time biling': 'enrolled in part-time bilingual program',
  'Dual lang': 'enrolled in dual language program (either one-way or two-way)',
  'Tpi student': 'transitional program of instruction',
  'Tbe student': 'transitional bilingual education',
  Lep: 'limited english proficiency',
  'Not lep': 'not classified as limited english proficiency',
  'Exited program':
    'student exited from bilingual or dual language program due to satisfactory ACCESS assessment score.',
  'No access, remained dl':
    'student has not taken ACCESS assessment and remains in dual language program',
  'Not eligible': 'student not eligible for LEP services'
};

export const fieldDefinitionsList = Object.entries(fieldDefinitions).map(
  ([key, definition]) => ({ key, definition })
);
